import { setUserInfo } from './user-info.function'
import { setAccessToken, setRefreshToken } from './user-tokens.function';

export const clearAuthSetup = () => {
    setUserInfo();
    setAccessToken();
    setRefreshToken();
}